import { useSlider } from 'components/SliderContext';
import React from 'react'

const CardsCollectionControls = () => {
  const { slideNext, slidePrev } = useSlider();

  return (
    <div className="cards-list__control">
      <button onClick={() => slidePrev()} className="cards-list__header-button cards-list__header-button--prev">
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M10 2.66663L4.66667 7.99995L10 13.3333" stroke="currentColor" strokeWidth="1.5" />
        </svg>
      </button>
      <button onClick={() => slideNext()} className="cards-list__header-button cards-list__header-button--next">
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M10 2.66663L4.66667 7.99995L10 13.3333" stroke="currentColor" strokeWidth="1.5" />
        </svg>
      </button>
    </div>
  )
}

export default CardsCollectionControls;
